module.exports = Object.freeze({
    PAGE_RECIPES_PATH: '/recipes',
    PAGE_RECIPES_DETAILS_PATH: '/recipes/:id',
    PAGE_CREATE_PATH: '/create',
    PAGE_CREATE_SUCCESS_PATH: '/create/success',
    FORM_REQUIRED_MESSAGE: 'Заполните это поле',
    FORM_NUMBER_MIN_MESSAGE: 'Должно быть больше',
    FORM_POSITIVE_MESSAGE: 'Должно быть положительным',
    FORM_NUMBER_TYPEERROR_MESSAGE: 'Введите число',
    INGREDIENT_NUM_WORDS: ['ингредиент', 'ингредиента', 'ингредиентов'],
    PORTIONS_NUM_WORDS: ['порция', 'порции', 'порций']
})